// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-landing"], () => (__webpack_require__("./apps/promo/browser/landing.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
